export default __webpack_public_path__ + "static/media/pantalon-militar-hombre.eda0e393.png";